import { AfterViewInit, Component, Inject } from '@angular/core';
import { ESystemAccess } from 'src/app/enum/EAccess';
import { SessionService } from 'src/app/shared/services/session.service';
import { SolicitudCreditoService } from 'src/app/shared/services/solicitud-credito.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface InputModel {
  rut: string;
}

@Component({
  selector: 'app-modal-listado',
  templateUrl: './modal-listado.component.html',
  styleUrls: ['./modal-listado.component.scss']
})
export class ModalListadoComponent implements AfterViewInit {

  inputModel: InputModel = {
    rut: ""
  };

  private access: string[] = [ESystemAccess.SOLICITUD_CREDITO_BUSCAR];
  public hasUserAccess = false;
  public showSpinner: boolean = false;
  public messages: { text: string, isError: boolean, isSuccess: boolean }[] = [];

  public header: any[] = ['numSolicitud', 'EstadoTransaccion', 'Modelo', 'date', 'search'];
  public dataTable: any[] = [];

  constructor(public dialogRef: MatDialogRef<ModalListadoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: InputModel, 
      private solicitudCreditoService: SolicitudCreditoService,
      private _sessionService: SessionService,
      private router: Router
    ) {
    
    this.inputModel = data;
    if (this._sessionService.getUserAccess().includes(this.access[0])) {
      this.hasUserAccess = true;
    }
    this.getData();
  }

  ngAfterViewInit(): void {
  }

  getData(): void {
    this.showSpinner = true;
    this.solicitudCreditoService.searchSolicitudesCreditoListFull(this.inputModel.rut).subscribe(resp => {
      this.showSpinner = false;
      this.dataTable = resp.filter((item: any) => item.EstadoTransaccion == 'CLOSED');
    }, (error: any) => {
      this.addMessage(error.error.message || 'Ocurrio un Error', true, false);
      this.showSpinner = false;
    });
  }

  addMessage(mensaje: string, isError: boolean, isSuccess: boolean) : void {
    this.messages.push({ text: mensaje, isError: isError, isSuccess: isSuccess });
  }

  removeMessage(index: number) {
    this.messages.splice(index, 1);
  }

  //cancel
  close() {
    this.dialogRef.close(false);
  }

  procesarEvent(event: any) {
    // Lógica para procesar el evento
    if(event?.type == 'search') {
      if(event?.obj?.IDTransaccion) {
        const url = this.router.serializeUrl(
          this.router.createUrlTree(['/solicitud-credito/resumen', event.obj.IDTransaccion])
        );
        window.open(url, '_blank');
      } else {
        this.addMessage('No se logró recuperar el ID de transacción', true, false);
      }
    } else {
      this.addMessage('Evento no reconocido en modal', true, false);
    }
  }

}
